module.exports = __webpack_public_path__ + "img/what_is_shp.09815bbd.png";